module.exports = __webpack_public_path__ + "static/img/qh_gjzlyjy.bf056e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/qh_gjzlyjy.jpg
// module id = Hj77
// module chunks = 0